import React, { useEffect, useState } from "react";

const ComponentRangeSlider = ({
  percentage: initialPercentage,
  leftLabel,
  rightLabel,
  color,
  isEditable,
  onChange,
}) => {
  const [percentage, setPercentage] = useState(initialPercentage);

  const handleChange = (e) => {
    const newValue = Number(e.target.value);
    setPercentage(newValue);
    if (onChange) {
      onChange(newValue);
    }
  };

  useEffect(() => {
    if (initialPercentage !== undefined) {
      setPercentage(initialPercentage);
    }
  }, [initialPercentage]);

  // Déterminer le texte et la position de la bulle selon le pourcentage
  const bubbleText =
    percentage > 50 ? `${percentage}% ${rightLabel}` : `${100 - percentage}% ${leftLabel}`;

  return (
    <div style={{ margin: "0px 0 0 30px", padding: "20px 10px", borderLeft: "1px black solid" }}>
      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "5px" }}>
        <span>{leftLabel}</span>
        <span>{rightLabel}</span>
      </div>
      <div
        style={{
          position: "relative",
          height: "10px",
          backgroundColor: "#e0e0e0",
          borderRadius: "5px",
        }}
      >
        <div
          style={{
            width: "100%",
            height: "100%",
            backgroundColor: color,
            borderRadius: "10px",
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            paddingRight: "10px",
            color: "white",
            fontWeight: "bold",
            boxShadow: "0 0 5px rgba(0, 0, 0, 0.2)",
          }}
        />
        {isEditable && (
          <input
            type="range"
            min="0"
            max="100"
            value={percentage}
            onChange={handleChange}
            style={{
              position: "absolute",
              top: "-10px",
              left: 0,
              width: "100%",
              height: "40px",
              opacity: 0,
              cursor: "pointer",
            }}
          />
        )}
        <div
          style={{
            position: "absolute",
            left: `${percentage}%`,
            top: "-5px",
            width: "20px",
            height: "20px",
            backgroundColor: "white",
            border: `3px solid ${color}`,
            borderRadius: "50%",
            transform: "translateX(-50%)",
          }}
        />
        {/* Bulle au-dessus du curseur */}
        <div
          style={{
            position: "absolute",
            left: `${percentage}%`,
            top: "15px",
            transform: `translateX(-${percentage}%)`,
            color: color,
            fontWeight: "bold",
            fontSize: "13px",
            minWidth: "130px",
            textAlign: "center",
          }}
        >
          {bubbleText}
        </div>
      </div>
    </div>
  );
};

export default ComponentRangeSlider;
